import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import Select from '../form/floating_label/select';
import { TFormOptions } from '../_component_types/form/form_options';
import getTranslatedText from '../../helper/get_translated_text';

function CatalogSorting(props) {
    const { productType } = props;
    const type = productType === 'wheel' ? 'wheels' : 'tyres';
    const translatedType = getTranslatedText(type).toLowerCase();
    return (
        <div className="catalog__sorting">
            <Translation
                translationKey="catalog-sorting-headline-for-wheel-and-tyre"
                className="catalog__sorting-headline"
                tagName="h2"
                placeholder={{ productType: translatedType }}
            />
            <Translation
                translationKey="catalog-sorting-headline-mobile"
                className="catalog__sorting-headline catalog__sorting-headline--mobile"
                tagName="h2"
            />
            <Select
                value={props.sorting}
                hasValue={!!props.sorting}
                options={props.sortingOptions}
                label=""
                name="sorting"
                onChange={props.onChange}
                additionalClassNames={['catalog__sorting-select']}
            />
        </div>
    );
}

CatalogSorting.propTypes = {
    sorting: PropTypes.string.isRequired,
    sortingOptions: TFormOptions.isRequired,
    onChange: PropTypes.func.isRequired,
    productType: PropTypes.string.isRequired,
};

export { CatalogSorting };
